module.exports = __webpack_public_path__ + "static/img/badge-no-spray-inactive.10afbe8.svg";